import { API_URL } from '../config';

/**
 * Generate a nose simulation based on user intent
 * 
 * @param {Object} params - Simulation parameters
 * @param {string} params.imageUrl - URL or identifier of the uploaded image
 * @param {string} params.userIntent - User's description of desired changes
 * @param {'natural'|'glam'} params.styleMode - Style preference
 * @param {number} params.intensity - Transformation intensity (0.2-1.0)
 * @returns {Promise<Object>} Response with success status and afterImageUrl
 */
export async function generateSimulation({ imageUrl, userIntent, styleMode, intensity }) {
  try {
    // Get or create session ID
    let sessionId = sessionStorage.getItem('rhinovate_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('rhinovate_session_id', sessionId);
    }
    
    // Create an AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 120000); // 120 second timeout
    
    const response = await fetch(`${API_URL}/generate-simulation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        imageUrl,
        userIntent,
        styleMode,
        intensity,
        sessionId,
        userId: null,  // Can be set if you have user authentication
      }),
      signal: controller.signal,
    });
    
    clearTimeout(timeoutId);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Request failed with status ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Simulation API error:', error);
    if (error.name === 'AbortError') {
      throw new Error('Request timed out. Image generation may take up to 2 minutes. Please try again.');
    }
    throw error;
  }
}

